import React from "react";
import PrintSafesMain from "../PrintSafesMain";

export default function ReviewTransfers(props) {
    const {dataPrint,closePrint ,infoPrint}=props
    return (
        <div>
            <PrintSafesMain typePrint={3} docNamePdf={"ReviewItems.pdf"} docName={"ReviewItems"}  
            dataPrint={dataPrint} closePrint={closePrint}/>
        </div>
    );
}